const pubMap = new Map([
  ["hbs", "hb"],
  ["peak", "tp"],
  ["icon", "ic"],
  ["nuyou", "ny"],
  ["female", "ff"],
  ["sww", "ww"],
]);

export const getPubShorthand = (vitePub: string) => {
  // Return original value if not in map
  return pubMap.get(vitePub) || vitePub;
};

export const defaultAMWidgetBreakpoints = [
  {
    containerMinWidth: 1000,
    visibleItems: 5,
  },
  {
    containerMinWidth: 600,
    visibleItems: 4,
  },
  {
    containerMinWidth: 420,
    visibleItems: 2,
  },
];
